/* eslint-disable prettier/prettier */
/* eslint-disable import/order */

import { registry } from "@nextgisweb/jsrealm/plugin/meta";

export * from "@nextgisweb/jsrealm/plugin/meta";

registry.registerLoader(
    "pyramid",
    () => import("@nextgisweb/pyramid/metrics/tab").then(({ registry }) => registry as any),
    { identity: "@nextgisweb/pyramid/metrics/tab" }
);

registry.registerLoader(
    "jsrealm",
    () => import("@nextgisweb/jsrealm/entrypoint/registry").then(({ registry }) => registry as any),
    { identity: "@nextgisweb/jsrealm/entrypoint/registry" }
);

registry.registerLoader(
    "jsrealm",
    () => import("@nextgisweb/jsrealm/plugin/testentry/registry").then(({ registry }) => registry as any),
    { identity: "@nextgisweb/jsrealm/plugin/testentry/registry" }
);

registry.registerLoader(
    "jsrealm",
    () => import("@nextgisweb/jsrealm/testentry/driver").then(({ registry }) => registry as any),
    { identity: "@nextgisweb/jsrealm/testentry/driver" }
);

registry.registerLoader(
    "jsrealm",
    () => import("@nextgisweb/jsrealm/testentry/registry").then(({ registry }) => registry as any),
    { identity: "@nextgisweb/jsrealm/testentry/registry" }
);

registry.registerLoader(
    "feature_layer",
    () => import("@nextgisweb/feature-layer/feature-editor/registry").then(({ registry }) => registry as any),
    { identity: "@nextgisweb/feature-layer/feature-editor/registry" }
);

registry.registerLoader(
    "webmap",
    () => import("@nextgisweb/webmap/identification/registry").then(({ registry }) => registry as any),
    { identity: "@nextgisweb/webmap/identification/registry" }
);

registry.registerLoader(
    "webmap",
    () => import("@nextgisweb/webmap/panel/registry").then(({ registry }) => registry as any),
    { identity: "@nextgisweb/webmap/panel/registry" }
);

registry.seal();
